'use client'

// src/lock/LockIcon.tsx
import { jsx } from "react/jsx-runtime";
var LockIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          id: "Main shape",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.33253 4.66359C3.33253 2.36195 5.19839 0.496094 7.50003 0.496094C9.80168 0.496094 11.6675 2.36195 11.6675 4.66359V6.33059H12.168C13.2726 6.33059 14.168 7.22602 14.168 8.33059V12.6656C14.168 13.7702 13.2726 14.6656 12.168 14.6656H2.83203C1.72746 14.6656 0.832031 13.7702 0.832031 12.6656V8.33059C0.832031 7.22602 1.72746 6.33059 2.83203 6.33059H3.33253V4.66359ZM7.50003 2.16309C6.11904 2.16309 4.99953 3.2826 4.99953 4.66359V6.33059H10.0005V4.66359C10.0005 3.28261 8.88102 2.16309 7.50003 2.16309Z",
          fill: "currentColor"
        }
      )
    }
  );
};

export {
  LockIcon
};
//# sourceMappingURL=chunk-FUCBMEKZ.mjs.map